// extracted by mini-css-extract-plugin
export default {"grid":"zTYq6A"};